import { render, staticRenderFns } from "./DashFornecedorFiltro.vue?vue&type=template&id=93f6aef0"
import script from "./DashFornecedorFiltro.vue?vue&type=script&lang=js"
export * from "./DashFornecedorFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports